(() => {
  const root = document.querySelector('[data-pd-snow]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const flakes = root.querySelector('[data-pd-snow-flakes]');
  function render() {
    root.hidden = motion.matches;
    root.dataset.paused = String(document.hidden || motion.matches);
    if (!motion.matches && !flakes.childElementCount) {
      const fragment = document.createDocumentFragment();
      for (let i = 0; i < 60; i++) {
        const flake = document.createElement('i');
        flake.style.cssText = `--x:${(i * 37 + 7) % 100}%;--size:${2 + i % 4}px;--drift:${(i * 17) % 70 - 35}px;--duration:${13 + i % 9}s;--delay:-${(i * 7) % 24}s;--alpha:${0.32 + (i % 4) * 0.13}`;
        fragment.appendChild(flake);
      }
      flakes.appendChild(fragment);
    }
  }
  document.addEventListener('visibilitychange', render);
  motion.addEventListener('change', render);
  render();
})();
